<template>
  <div>

		<CargaInicial v-if="!$root.autenticación.cargaInicial"></CargaInicial>

		<v-container fluid fill-height v-else-if="$root.autenticación.cargaInicial && !$root.autenticación.usuario" style="height: 100vh;">
			<v-layout align-center justify-center>
				<v-flex xs12 sm8 md4>
					<v-card width="800">
						<v-progress-linear
							v-if="!$root.autenticación.cargaInicial"
							vvv-if="true"
							color="deep-purple accent-4"
							indeterminate
							rounded
							height="6"
						></v-progress-linear>
						<Ingreso
							style="min-width: 300px"
						></Ingreso>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>

		<div v-else-if="$root.autenticación.cargaInicial && $root.autenticación.usuario">

			<v-navigation-drawer
				v-model="verMenú"
				:clipped="$vuetify.breakpoint.lgAndUp"
				app
			>
				<v-list dense>
					<template v-for="item in menú">
						<v-row
							v-if="item.encabezado"
							:key="item.encabezado"
							align="center"
						>
							<v-col cols="6">
								<v-subheader v-if="item.encabezado">
									{{ item.encabezado }}
								</v-subheader>
							</v-col>
							<v-col
								cols="6"
								class="text-center"
							>
								<a
									href="#!"
									class="body-2 black--text"
								>EDITAR</a>
							</v-col>
						</v-row>
						<v-list-group
							v-if="item.submenú"
							:key="item.título"
							v-model="item.modelo"
							:prepend-icon="item.modelo ? item.ícono : item['ícono-alt']"
							append-icon=""
						>
							<template v-slot:activator>
								<v-list-item-content>
									<v-list-item-title>
										{{ item.título }}
									</v-list-item-title>
								</v-list-item-content>
							</template>
							<v-list-item
								v-for="(sm, i) in item.submenú"
								:key="i"
								link
							>
								<v-list-item-action v-if="sm.ícono">
									<v-icon>{{ sm.ícono }}</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title>
										{{ sm.título }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
						<v-list-item
							v-else
							:key="item.título"
							:to="item.enlace"
							link
						>
							<v-list-item-action>
								<v-icon>{{ item.ícono }}</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>
									{{ item.título }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
				</v-list>
			</v-navigation-drawer>

			<v-app-bar
				:clipped-left="$vuetify.breakpoint.lgAndUp"
				app
				color="blue darken-3"
				dark
			>
				<v-app-bar-nav-icon @click.stop="verMenú = !verMenú">
					<v-icon>mdi-menu</v-icon>
				</v-app-bar-nav-icon>
				<v-toolbar-title
					style="width: 300px"
					class="ml-0 pl-4"
				>
					<v-btn v-if="mostrarÍconoInicio" @click="mostrarMenu()" icon to="/administración"><v-icon>mdi-home</v-icon></v-btn>
					<span class="hidden-sm-and-down">Constructor de sitios web</span>
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<h3 class="px-3"> {{ $root.cuenta.nombre }} </h3>
				<v-menu
					bottom
					left
					offset-y
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							v-bind="attrs"
							v-on="on"
						>
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>

					<v-list>
						<v-list-item @click="$root.firebase.auth().signOut(); $router.push('/')">
							<v-list-item-title>Cerrar sesión</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				<!--<v-text-field
					flat
					solo-inverted
					hide-details
					prepend-inner-icon="mdi-magnify"
					label="Search"
					class="hidden-sm-and-down"
				></v-text-field>
				<v-spacer></v-spacer>
				<v-btn icon>
					<v-icon>mdi-apps</v-icon>
				</v-btn>
				<v-btn icon>
					<v-icon>mdi-bell</v-icon>
				</v-btn>
				<v-btn
					icon
					large
				>
					<v-avatar
						size="32px"
						item
					>
						<v-img
							src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
							alt="Vuetify"
						></v-img></v-avatar>
				</v-btn>-->
			</v-app-bar>
			<v-main>
				<v-container
					class="pa-0"
					fluid
				>
					<!--<v-content style="height: 100%">-->
						<router-view @ocultarMenu="alOcultarMenu"></router-view>
						<!--<router-view name="dominio-constructor-vista"></router-view>-->
						<!--<Constructor></Constructor>-->
					<!--</v-content>-->
					<!--<v-row
						align="center"
						justify="center"
					>
						<v-tooltip right>
							<template v-slot:activator="{ on }">
								<v-btn
									:href="source"
									icon
									large
									target="_blank"
									v-on="on"
								>
									<v-icon large>mdi-code-tags</v-icon>
								</v-btn>
							</template>
							<span>Source</span>
						</v-tooltip>
					</v-row>-->
				</v-container>
			</v-main>
			<!--<v-btn
				bottom
				color="pink"
				dark
				fab
				fixed
				right
				@click="dialog = !dialog"
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
			<v-dialog
				v-model="dialog"
				width="800px"
			>
				<v-card>
					<v-card-title class="grey darken-2">
						Create contact
					</v-card-title>
					<v-container>
						<v-row class="mx-2">
							<v-col
								class="align-center justify-space-between"
								cols="12"
							>
								<v-row
									align="center"
									class="mr-0"
								>
									<v-avatar
										size="40px"
										class="mx-3"
									>
										<img
											src="//ssl.gstatic.com/s2/oz/images/sge/grey_silhouette.png"
											alt=""
										>
									</v-avatar>
									<v-text-field
										placeholder="Name"
									></v-text-field>
								</v-row>
							</v-col>
							<v-col cols="6">
								<v-text-field
									prepend-icon="mdi-account-card-details-outline"
									placeholder="Company"
								></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field
									placeholder="Job title"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									prepend-icon="mdi-mail"
									placeholder="Email"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									type="tel"
									prepend-icon="mdi-phone"
									placeholder="(000) 000 - 0000"
								></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-text-field
									prepend-icon="mdi-text"
									placeholder="Notes"
								></v-text-field>
							</v-col>
						</v-row>
					</v-container>
					<v-card-actions>
						<v-btn
							text
							color="primary"
						>More</v-btn>
						<v-spacer></v-spacer>
						<v-btn
							text
							color="primary"
							@click="dialog = false"
						>Cancel</v-btn>
						<v-btn
							text
							@click="dialog = false"
						>Save</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>-->

		</div>

  </div>
</template>

<script>
import CargaInicial from '@/views/CargaInicial'
import Ingreso from '@/views/ingreso'

export default {
  name: 'Administracion',

  components: {
		CargaInicial,
		Ingreso
  },

  data: () => ({
    /*dialog: false,
		//drawer: null,
		items: [
			{ icon: 'mdi-contacts', text: 'Contacts' },
			{ icon: 'mdi-history', text: 'Frequently contacted' },
			{ icon: 'mdi-content-copy', text: 'Duplicates' },
			{
				icon: 'mdi-chevron-up',
				'icon-alt': 'mdi-chevron-down',
				text: 'Labels',
				model: true,
				children: [
					{ icon: 'mdi-plus', text: 'Create label' },
				],
			},
			{
				icon: 'mdi-chevron-up',
				'icon-alt': 'mdi-chevron-down',
				text: 'More',
				model: false,
				children: [
					{ text: 'Import' },
					{ text: 'Export' },
					{ text: 'Print' },
					{ text: 'Undo changes' },
					{ text: 'Other contacts' },
				],
			},
			{ icon: 'mdi-cog', text: 'Settings' },
			{ icon: 'mdi-message', text: 'Send feedback' },
			{ icon: 'mdi-help-circle', text: 'Help' },
			{ icon: 'mdi-cellphone-link', text: 'App downloads' },
			{ icon: 'mdi-keyboard', text: 'Go to the old version' },
		],*/
		verMenú: null,
		mostrarÍconoInicio: false,
		menú: [
			{ título: 'Inicio', ícono: 'mdi-home', enlace: '/administración' },
			{ título: 'Archivos multimedia', ícono: 'mdi-file-multiple', enlace: '/administración/archivos' },
			//{ título: 'Creador de sitios web', ícono: 'mdi-application' },
			//{ título: 'Nombres de dominios', ícono: 'mdi-web' },
			//{ título: 'Correo electrónico', ícono: 'mdi-email' }
		],
	}),
	methods: {
		alOcultarMenu: function(e) {
			this.$nextTick(() => {
				this.verMenú = false
				this.mostrarÍconoInicio = true
			})
		},
		mostrarMenu: function(e) {
			this.verMenú = true
			this.mostrarÍconoInicio = false
		}
	}
};
</script>
